import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Divider, Drawer } from '@material-ui/core';
import ConnectedClearAllFilters from './Algolia/ConnectedClearAllFilters';
import ConnectedMenu from './Algolia/ConnectedMenu';
import ConnectedList from './Algolia/ConnectedList';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 300,
    flexShrink: 0,
  },
  drawerPaper: {
    top: 65,
    width: 300,
  },
}));

export default function SideFilters(props) {
  const classes = useStyles();

  const { drawerState } = props;
  return (
    <Drawer
      className={classes.drawer}
      variant="persistent"
      anchor="left"
      open={drawerState}
      classes={{
        paper: classes.drawerPaper,
      }}
    >
      <ConnectedClearAllFilters />
      <ConnectedMenu
        title="Programs"
        attribute="ProgramName"
        defaultRefinement="Fame"
      />
      <Divider />
      <ConnectedMenu
        title="Sizes"
        searchable={true}
        attribute="Size"
        defaultRefinement="300x250"
        limit={6}
        showMore={true}
      />
      <Divider />
      <ConnectedMenu title="Niches" attribute="Niche" />
      <Divider />

      <ConnectedMenu title="Media Types" attribute="MediaExt" />
      <Divider />
      <ConnectedMenu
        title="Sites"
        attribute="SiteTag"
        limit={8}
        showMore
        searchable={true}
      />
      <Divider />
      <ConnectedMenu
        title="Overlays"
        attribute="OverlayName"
        limit={6}
        searchable={true}
        showMore={true}
        showMoreLimit={100}
      />
      <Divider />
      <ConnectedList
        title="Scene Actors"
        attribute="SceneActors"
        operator="and"
        limit={10}
        showMore
        enableCheckbox
        searchable={true}
      />
      <Divider />
      <ConnectedList
        title="Scene Categories"
        attribute="SceneCategories"
        operator="and"
        limit={10}
        showMoreLimit={100}
        showMore
        enableCheckbox
        searchable={true}
      />
      <div style={{ margin: 50 }} />
    </Drawer>
  );
}



// WEBPACK FOOTER //
// ./src/components/SideFilters.js